import { render, staticRenderFns } from "./RatingsEdit.vue?vue&type=template&id=43273195&"
import script from "./RatingsEdit.vue?vue&type=script&lang=js&"
export * from "./RatingsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports